"use strict";
export function getNavigationGroupClassName(group) {
  var _a;
  if (typeof group === "string") {
    console.warn(`Group passed in to navigation was a string value (${group}) and not navigation group info, fix ASAP.`);
    return group;
  }
  if (typeof group.id === "undefined") {
    return "hi";
  }
  return (_a = group.className) != null ? _a : group.id.toLowerCase();
}
